import { render, staticRenderFns } from "./ModalWindow.Vue?vue&type=template&id=77790124"
import script from "./ModalWindow.Vue?vue&type=script&lang=js"
export * from "./ModalWindow.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalWindow.Vue
// module id = 6
// module chunks = 0